"use client";

import { useEffect } from "react";

import { useAppDispatch } from "../hooks";
import { fetchWalletSummary } from "../thunks";
import { useAuthState } from "./authSlice";
import { useWalletState } from "./walletSlice";

// Isolated in its own "use client" module so importing the wallet reducer
// (e.g. from store.ts) never pulls a React hook into a server-only import graph.
export function useWalletSummary() {
  const dispatch = useAppDispatch();
  const auth = useAuthState();
  const email = auth?.user?.email;
  const { summary, summaryStatus, summaryError } = useWalletState();
  useEffect(() => {
    if (summaryStatus === "idle" && email) dispatch(fetchWalletSummary(email));
  }, [summaryStatus, email, dispatch]);
  return { summary, summaryStatus, summaryError };
}
